// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePicker_container__2V6OP","icon":"DatePicker_icon__Ad4A3"};